import { ComponentProps } from "react";
import Input, { InputProps } from "../input/input";
import Checkbox, { CheckboxProps } from "../checkbox/checkbox";
import StateInput, { StateInputProps } from "../input/stateInput";
import TextArea, { TextAreaProps } from "../textArea/textArea";
import WithValidation, { ValidityMessages, WithValidationProps } from "./with_validation";
import WithValidationErrorPopup from "./with_popup_error_message";

const ValidationInput = WithValidation(Input);
const ValidationCheckbox = WithValidation(Checkbox);
const ValidationStateInput = WithValidation(StateInput);
const ValidationTextArea = WithValidation(TextArea);

const ValidationPopupInput = WithValidationErrorPopup<
    InputProps & WithValidationProps
>(ValidationInput, {
    uiErrorProp: "uiError",
});

const ValidationPopupCheckbox = WithValidationErrorPopup<
    CheckboxProps & WithValidationProps
>(ValidationCheckbox, {
    uiErrorProp: "uiError",
});

const ValidationPopupStateInput = WithValidationErrorPopup<
    StateInputProps & WithValidationProps
>(ValidationStateInput, {
    uiAsyncValidationStatusProp: "uiState",
    uiErrorProp: "uiError",
});

const ValidationPopupTextArea = WithValidationErrorPopup<
    TextAreaProps & WithValidationProps
>(ValidationTextArea, {
    uiErrorProp: "uiError",
});

export {
    ValidationInput,
    ValidationPopupInput,
    ValidationCheckbox,
    ValidationPopupCheckbox,
    ValidationStateInput,
    ValidationPopupStateInput,
    ValidationTextArea,
    ValidationPopupTextArea,
};

export type ValidationInputProps = ComponentProps<typeof ValidationInput>;
export type ValidationPopupInputProps = ComponentProps<typeof ValidationPopupInput>;
export type ValidationCheckboxProps = ComponentProps<typeof ValidationCheckbox>;
export type ValidationPopupCheckboxProps = ComponentProps<typeof ValidationPopupCheckbox>;
export type ValidationStateInputProps = ComponentProps<typeof ValidationStateInput>;
export type ValidationPopupStateInputProps = ComponentProps<typeof ValidationPopupStateInput>;
export type ValidationTextAreaProps = ComponentProps<typeof ValidationTextArea>;
export type ValidationPopupTextAreaProps = ComponentProps<typeof ValidationPopupTextArea>;

export type ValidityMessagesMap<Keys extends string> = {
    [T in Keys]: ValidityMessages;
};
